import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Button } from 'components'
import ThemeOption from './ThemeOption'

const Container = styled.div`
    overflow: hidden;
`

const Title = styled.div`
    font-size: 3rem;
    font-weight: bolder;
    align-self: flex-start;
`

const Subtitle = styled.div`
    font-size: 1rem;
    /* font-weight: bold; */
    align-self: flex-start;
`

const Field = styled.div`
    margin: 1rem 0;
    display: grid;
    grid-template-columns: 47.5% 47.5%;
    grid-gap: 5%;
    justify-items: stretch;

`

const ThemeTab = props => {
    const {
        value,
        onChange,
        onSubmit,
    } = props

    return (
        <Container>
            <Title>Welcome!</Title>
            <Subtitle>Choose a theme!</Subtitle>
            <Field>
                <ThemeOption theme='Dark' selected={value === 'Dark'} onSelect={() => onChange('Dark')}/>
                <ThemeOption theme='Light' selected={value === 'Light'} onSelect={() => onChange('Light')}/>
            </Field>            
        </Container>
    )
}

export default ThemeTab

ThemeTab.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func
}